<template>
    <div class="size-1-5 inline-card-cont">
        <div class='tep-tmp-open-btn'>
            <dx-button hint="Справочник ЦТП" width='32px' height='32px' @click="openNsi">
                <img :src="'/infoenergo/assets/tep/tep-cards/arrow-right.svg'" alt='' class='w-full h-full'>
            </dx-button>

            <dx-popup
                ref="popupRef"
                height="95%"
                title="Справочник ЦТП"
                :drag-enabled="true"
                :hide-on-outside-click="false"
                :show-close-button="true"
                :show-title="true"
                :visible="popupVisible"
                @hiding='onNsiClose'
            >
                <qs-ctp-kaz-view ref='nsiRef' :from-card='true' @choose-ctp='onChooseCtp' />
            </dx-popup>
        </div>
        <div style='flex: 1'>
            <ai-form-text-box-readonly :meta='{fieldNameText: "ctp_name"}' :server-data='currentCtp'></ai-form-text-box-readonly>
        </div>
    </div>
    <div class='size-1-1'>
        <ai-form-radio-box :meta='meta.radioMeta' :callbacks='{userDataChanged: callbacks.userDataChanged}' :disable-value='radioDisabled'/>
    </div>
</template>

<script setup>
import { DxButton, DxPopup } from 'devextreme-vue';
import AiFormTextBoxReadonly from '@/components/card-component/ai-form-text-box-readonly.vue';
import { dxUiNotify } from '@/utils/dx-helper';
import { inject, onMounted, ref } from 'vue';
import AiFormRadioBox from '@/components/card-component/ai-form-radio-box.vue';
import QsCtpKazView from '@/views/tep/tep-nsi/qs-ctp-kaz-view.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    }
});
const userData = inject('userData');

const currentCtp = ref({
    kod_ctp: null,
    ctp_name: ''
});
const radioDisabled = ref(false);
const popupVisible = ref(false);
const nsiRef = ref(null);
const popupRef = ref(null);

onMounted(() => {
    const ctpKod = props.serverData.kod_ctp;
    const ctpName = props.serverData.ctp_name;
    currentCtp.value = {
        kod_ctp: ctpKod,
        ctp_name: ctpName
    }
    userData.value.kod_ctp = ctpKod;
    userData.value.ctp_name = ctpName;
    radioDisabled.value = !ctpKod;
})

const openNsi = () => {
    popupVisible.value = true;
}

const onNsiClose = (e) => {
    if (popupVisible.value) {
        e.cancel = true;
        nsiRef.value?.beforeNsiClose(); // эта функция вызовет через emit функцию onChooseCtp и закроет при необходимости popup
    }
}

const onChooseCtp = (selectedRows) => {
    if (!selectedRows || selectedRows && selectedRows.length === 0) {
        popupVisible.value = false;
        popupRef.value?.instance.hide();
        return;
    }
    if (selectedRows && selectedRows.length !== 1) {
        dxUiNotify('Выбрано несколько объектов. Выберите один ЦТП для применения изменений.', 'error', 5000);
        return;
    }

    const selectedCtp = selectedRows[0];
    const ctpKod = selectedCtp.kod_ctp;
    let ctpName = selectedCtp.name + ', ' + selectedCtp.str_adr;
    if (selectedCtp.str_reg) ctpName += ', ' + selectedCtp.str_reg;
    currentCtp.value = {
        kod_ctp: ctpKod,
        ctp_name: ctpName
    }
    userData.value.kod_ctp = ctpKod;
    userData.value.ctp_name = ctpName;
    radioDisabled.value = !ctpKod;
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    popupVisible.value = false;
    popupRef.value?.instance.hide();
}
</script>

<style scoped>
.inline-card-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.inline-card-cont :deep(.dx-field) {
    margin: 0 10px;
}
.tep-tmp-open-btn {
    display: flex;
    align-items: end;
    height: 66px;
    padding: 10px 0;
}
</style>
